<template>
  <div class="login-view">
    <div class="login-view__content">
      <img class="login-view__main-image" src="@/assets/images/logo-dispensacion.svg">
      <h4>Dispensación de medicamentos</h4>
      <h5>Ingresa con tu <strong>Clave Única</strong></h5>

      <a class="btn-cu" :href="urlLoginClaveUnica">
        <img src="@/assets/images/claveunica/claveunica.svg" alt="Clave Única">
        <span class="texto">Iniciar sesión</span>
      </a>

      <p>Para acceder a esta aplicación debes tener tu Clave Única activa y estar autorizado en la plataforma.</p>
      <p><a href="https://claveunica.gob.cl/como-obtenerla" target="_blank">Descubre cómo obtener o activar tu Clave Única</a></p>
      <div class="version">
        v0.7.10.2
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  computed: {
    urlLoginClaveUnica() {
      return `${process.env.VUE_APP_API_URL}/login/claveunica`;
    }
  },
  created() {
    this.handleErrorMessages();
  },
  methods: {
    handleErrorMessages() {
      const urlParams = new URLSearchParams(window.location.search);
      const error = urlParams.get('error');
      if (error === 'invalid-user') {
        this.$message({
          showClose: true,
          message: 'El usuario no está autorizado para ingresar al módulo de dispensación.',
          type: 'error'
        });
      }
      if (error === 'error-me') {
        this.$message({
          showClose: true,
          message: 'Ocurrió un error al intentar verificar el usuario, por favor intente más tarde.',
          type: 'error'
        });
      }
    }
  }
};
</script>

<style lang="scss">
.login-view {
  color: $--color-white;

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 450px;
    margin: 0 auto;
    padding: 100px 0;
  }

  &__main-image {
    margin: 0 0 $--spacing-6 * 3 0;
  }

  &__bottom-image {
    margin-top: $--spacing-6 * 2;
    max-width: 200px;
  }

  &__btn-claveunica {
    margin: $--spacing-6 0;
  }

  h4 {
    padding-bottom: $--spacing-6;
    margin-bottom: $--spacing-6;
    border-bottom: 1px solid #78858D;
    width: 100%;
    text-align: center;
  }

  a {
    color: $--color-white;
    text-decoration: underline;
  }
  .version{
    color: #777
  }
}
</style>
